import React from "react";
import NewsletterForm from "@/components/NewsletterForm";

export default function Hero() {
    return (
        <section className="relative z-10" data-testid="hero-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-6">
                <div className="panel p-8 md:p-12 fade-up">
                    <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_420px] gap-10 lg:gap-16 items-start">
                        {/* Left: copy */}
                        <div>
                            <div className="flex items-center gap-3 mb-7 overline-cobalt">
                                <span
                                    className="inline-block"
                                    style={{
                                        width: 32,
                                        height: 1,
                                        background: "var(--cobalt)",
                                    }}
                                />
                                F/01 — By invitation. At the frontier.
                            </div>

                            <h1
                                className="font-display text-[var(--ink)] max-w-[16ch]"
                                style={{
                                    fontSize: "clamp(48px, 6.4vw, 104px)",
                                    lineHeight: 0.94,
                                }}
                                data-testid="hero-headline"
                            >
                                Frontier{" "}
                                <span style={{ color: "var(--cobalt)" }}>//</span>
                                <br />
                                Signal from the{" "}
                                <span
                                    style={{
                                        fontFamily: "'Fraunces', serif",
                                        fontStyle: "italic",
                                        fontWeight: 400,
                                        color: "var(--cobalt)",
                                        letterSpacing: "-0.02em",
                                    }}
                                >
                                    edge.
                                </span>
                            </h1>

                            <p
                                className="mt-7 max-w-[560px]"
                                style={{
                                    color: "var(--ink-2)",
                                    fontSize: 16,
                                    lineHeight: 1.7,
                                }}
                            >
                                A private network for frontier builders and
                                backers. Weekly intelligence on the companies
                                defining the next era — space, robotics, nuclear,
                                defense, deep computing. Written for the few who
                                will build them.
                            </p>
                        </div>

                        {/* Right: inline newsletter form */}
                        <div
                            className="p-7 md:p-8"
                            style={{
                                background: "white",
                                border: "1px solid var(--rule)",
                            }}
                            data-testid="hero-newsletter-box"
                        >
                            <NewsletterForm bg="steel" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
